module.exports = __webpack_public_path__ + "static/media/Cartridge.3272b8e2.png";